import { api } from "@/lib/api";
import { applyTrackOverrides } from "@/data/playalong";

let pending = null;
export const loadTrackOverrides = (force = false) => {
  if (!pending || force) {
    pending = api.get("/tracks/overrides").then(({ data }) => applyTrackOverrides(data.overrides)).catch(() => {});
  }
  return pending;
};
